import * as React from 'react';
import { useState, FunctionComponent } from 'react';
import { ActionItem } from './ActionsButton';

interface Props {
  item: any;
  onItemClick: (actionItem: ActionItem) => void;
}

export const DropdownMenuItem: FunctionComponent<Props> = props => {
  const { item, onItemClick } = props;
  const { subItems, itemText, isActive, iconType, isDanger } = item;

  const dropdownItemClasses = [
    'dropdown-item',
    'd-flex',
    'justify-content-between',
    'align-items-center',
    iconType ? 'mDropdownItemWithIcon' : '',
    isDanger ? 'mDropdownItemDanger' : ''
  ]
    .filter(Boolean)
    .join(' ');

  const isSubItemsExist = typeof subItems !== 'undefined' && subItems.length > 0;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const renderIcon = () => {
    if (!iconType) {
      return null;
    }

    const paths: Record<string, string> = {
      duplicate:
        'M8 8h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2zM4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2',
      add: 'M12 5v14M5 12h14',
      results: 'M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-8',
      points: 'M12 3l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 18.8 5.9 21.4l1.4-6.8L2.2 10l6.9-.7z',
      consent: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
      cancel: 'M18 6 6 18M6 6l12 12',
      restore: 'M3 12a9 9 0 1 0 3-6.7M3 4v6h6',
      availability: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
      csv: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5',
      delete: 'M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6',
      import: 'M12 3v12M7 10l5 5 5-5M5 21h14',
      export: 'M12 21V9M7 14l5-5 5 5M5 3h14',
      board: 'M3 3h18v14H3zM8 21h8M12 17v4',
      video: 'M23 7l-7 5 7 5V7zM3 5h13v14H3z',
      report: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M9 13h6M9 17h4',
      notification: 'M22 2 11 13M22 2l-7 20-4-9-9-4z',
      edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z',
      more: 'M12 6h.01M12 12h.01M12 18h.01'
    };

    return (
      <svg className="mDropdownItemIcon" viewBox="0 0 24 24" aria-hidden="true">
        <path d={paths[iconType] || paths.more} />
      </svg>
    );
  };

  const renderItems = () => {
    let result = [];

    if (isSubItemsExist) {
      subItems.map((item, index) => {
        result.push(<DropdownMenuItem key={`dropdownMenuItem_${index}`} item={item} onItemClick={onItemClick} />);
      });
    }

    return result;
  };

  return (
    <div className="bDropdownMenuItem">
      <span
        className={isActive ? dropdownItemClasses : `${dropdownItemClasses} disabled`}
        onClick={() => (isSubItemsExist ? setIsOpen(!isOpen) : onItemClick(item))}
      >
        <span className="mDropdownItemLabel">
          {renderIcon()}
          {itemText}
        </span>
        {isSubItemsExist && (
          <svg
            className={isOpen ? 'mDropdownMenuItemIcon' : 'dropdownMenuItemArrow'}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        )}
      </span>

      {isOpen && <div className="bSubMenuWrapper">{renderItems()}</div>}
    </div>
  );
};
